import {
    GuxFormFieldRadio,
    GuxFormFieldRadioGroupBeta,
} from "genesys-spark-components-react";

type RadioOption<T extends string> = {
    value: T;
    label: string;
    testId?: string;
};

function AgentScoringRuleRadioOption<T extends string>({
    name,
    value,
    checked,
    label,
    onChange,
    testId,
}: {
    name: string;
    value: T;
    checked: boolean;
    label: string;
    onChange: (value: T) => void;
    testId?: string;
}) {
    return (
        <GuxFormFieldRadio>
            <input
                slot="input"
                type="radio"
                name={name}
                checked={checked}
                onChange={() => onChange(value)}
                data-testid={testId}
            />
            <label slot="label">{label}</label>
        </GuxFormFieldRadio>
    );
}

export function AgentScoringRuleRadioGroup<T extends string>({
    name,
    groupLabel,
    value,
    options,
    onChange,
}: {
    name: string;
    groupLabel: string;
    value: T | undefined;
    options: readonly RadioOption<T>[];
    onChange: (value: T) => void;
}) {
    return (
        <GuxFormFieldRadioGroupBeta>
            <label slot="group-label">{groupLabel}</label>
            {options.map((option) => (
                <AgentScoringRuleRadioOption
                    key={option.value}
                    name={name}
                    value={option.value}
                    checked={value === option.value}
                    label={option.label}
                    onChange={onChange}
                    testId={option.testId}
                />
            ))}
        </GuxFormFieldRadioGroupBeta>
    );
}
